/*
  Everlles: show the value name and the add-on price UNDER every Easify image swatch.

  Easify puts the label + price of a swatch in a hover tooltip (label position "hover") and the
  theme hides that tooltip, so a customer picking "Gold Plated (+$20)" never saw the surcharge on
  the swatch itself — only in the total above Add to cart. This script copies the tooltip's label
  and price into a visible caption below each swatch: "Gold Plated" / "+$20".

  Works on every product without configuration; re-runs whenever Easify re-renders its options.
*/
(function () {
  var CAP = 'ev-swatch-cap';

  function money(txt) {
    // "$20.00" / "+$4.99" / "(20.00)" -> "+$20" / "+$4.99"; empty when there is no price
    var m = String(txt || '').match(/([+-]?)\s*([^\d\s()+-]*)\s*(\d+(?:[.,]\d+)?)/);
    if (!m) return '';
    var sym = m[2] || '$';
    var n = parseFloat(m[3].replace(',', '.'));
    if (isNaN(n) || n === 0) return '';
    var out = n % 1 === 0 ? String(n) : n.toFixed(2);
    return (m[1] === '-' ? '-' : '+') + sym + out;
  }

  // Split "Gold Plated ($20.00)" or "18K Gold Plated $20.00" or "Silver" into name + price text
  function split(full) {
    var m = full.match(/^(.*?)\s*\(\s*([^()]*\d[^()]*)\)\s*$/);
    if (m) return { name: m[1].trim(), price: m[2] };
    m = full.match(/^(.*?)\s+([+-]?[^\d\s]{0,3}\d[\d.,]*)\s*$/);
    if (m && m[1].trim()) return { name: m[1].trim(), price: m[2] };
    return { name: full, price: '' };
  }

  function caption(wrapper) {
    if (wrapper.querySelector('.' + CAP)) return;
    var tip = wrapper.querySelector('.tpo_image-swatches-tooltip');
    var input = wrapper.querySelector('input');
    var name = '';
    var priceTxt = '';
    if (tip) {
      var labelEl = tip.querySelector('.tpo_option_type_label');
      var lp = tip.querySelector('.tpo_option_type_label_and_price');
      var full = (lp || labelEl) ? (lp || labelEl).textContent.replace(/\s+/g, ' ').trim() : '';
      if (full) {
        var parts = split(full);
        name = parts.name;
        priceTxt = parts.price;
      }
    }
    if (!name && input) {
      var parts2 = split(String(input.value || '').replace(/\s+/g, ' ').trim());
      name = parts2.name;
      priceTxt = parts2.price;
    }
    if (!name) return;
    var price = money(priceTxt);
    var cap = document.createElement('span');
    cap.className = CAP;
    var n = document.createElement('span');
    n.className = CAP + '__name';
    n.textContent = name;
    cap.appendChild(n);
    if (price) {
      var p = document.createElement('b');
      p.className = CAP + '__price';
      p.textContent = price;
      cap.appendChild(p);
    }
    var label = wrapper.querySelector('label');
    if (label && label.nextSibling) wrapper.insertBefore(cap, label.nextSibling);
    else wrapper.appendChild(cap);
    wrapper.classList.add('ev-has-cap');
  }


  // 2026-10-01: Easify BUTTON options ("Yes Please!") also keep their price only in the hidden hover
  // tooltip -> write "(+$4.99)" into the pill, unless the value name already carries a price
  // (the Spanish sets are named "¡Sí por favor! (+$4.99)").
  var BTN = 'ev-btn-price';
  function buttonPrice(label) {
    if (label.querySelector('.' + BTN)) return;
    var box = label.closest('.tpo_buttons-wrapper') || label; // the tooltip is the label's sibling
    var tip = box.querySelector('.tpo_buttons-tooltip');
    var val = label.querySelector('.tpo_button_option_value');
    if (!tip || !val) return;
    var price = money(tip.textContent);
    if (!price || /\(\s*[+-]|[+-]\s*[^\d\s]{0,3}\d/.test(val.textContent)) return;
    var p = document.createElement('span');
    p.className = BTN;
    p.textContent = '(' + price + ')';
    val.parentNode.insertBefore(p, val.nextSibling);
  }

  // 2026-09-28: the LED box photo (Screenshot_2026-05-07_at_17.40.33…) has a black last pixel column
  // that shows as a thin grey line inside the option tile -> ask Shopify's CDN for a region crop.
  var LED_FILE = 'Screenshot_2026-05-07_at_17.40.33_'; // two uploads of the same photo (7def6870… and 9370c179…)
  var LED_CROP = 'crop=region&crop_left=0&crop_top=0&crop_width=1340&crop_height=1348&width=600';
  function cropLed() {
    var imgs = document.querySelectorAll('img[src*="' + LED_FILE + '"]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.src.indexOf('crop=region') !== -1) continue;
      img.removeAttribute('srcset');
      var base = img.src.replace(/_\d+x(\.png)/i, '$1'); // drop a legacy "_500x" size suffix so the crop maps to the original
      img.src = base + (base.indexOf('?') === -1 ? '?' : '&') + LED_CROP;
    }
  }

  // 2026-10-26: some Easify value names carry a hard-coded USD price ("2 Bead (+$3)", "¡Sí por favor! (+$4.99)").
  // Outside the US market convert it with the storefront rate, the same way Easify converts its own charge
  // (unrounded rate, 2 decimals: $3 at 0.7605 -> £2.28). Only text nodes change; Easify's inputs keep their values.
  var USD_RE = /\(\+\s*\$\s*(\d+(?:\.\d+)?)(?:\s*USD)?\s*\)/g;
  function localMoney(usd) {
    var c = window.Shopify && window.Shopify.currency;
    if (!c || !c.active || c.active === 'USD') return '';
    var v = Math.round(usd * parseFloat(c.rate) * 100) / 100;
    if (!v) return '';
    var whole = v % 1 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: c.active,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      }).format(v);
    } catch (e) {
      return c.active + ' ' + v.toFixed(whole ? 0 : 2);
    }
  }
  // AUD/CAD/NZD also format as "$", so a converted label matches USD_RE again: remember what each text node
  // was turned into and never convert that output a second time (it compounded on every DOM change).
  var converted = typeof WeakMap === 'function' ? new WeakMap() : null;
  function convertUsdLabels() {
    var c = window.Shopify && window.Shopify.currency;
    if (!c || !c.active || c.active === 'USD' || !converted) return;
    var roots = document.querySelectorAll('.tpo_option-set-wrapper');
    for (var r = 0; r < roots.length; r++) {
      var walker = document.createTreeWalker(roots[r], NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.indexOf('$') === -1 || converted.get(node) === node.nodeValue) continue;
        var next = node.nodeValue.replace(USD_RE, function (m, n) {
          var s = localMoney(parseFloat(n));
          return s ? '(+' + s + ')' : m;
        });
        if (next !== node.nodeValue) {
          node.nodeValue = next;
          converted.set(node, next);
        }
      }
    }
  }

  function run() {
    cropLed();
    convertUsdLabels();
    var list = document.querySelectorAll('.tpo_image-swatches-wrapper.tpo_image-swatch-hover');
    for (var i = 0; i < list.length; i++) caption(list[i]);
    var btns = document.querySelectorAll('.tpo_option-type-buttons-wrapper label');
    for (var j = 0; j < btns.length; j++) buttonPrice(btns[j]);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      run();
    }, 120);
  }


  // 2026-09-28: the whole card is clickable. Easify only reacts to a pointer sequence on the swatch
  // IMAGE, so a tap on the card padding or the caption is forwarded to that image.
  function forward(e) {
    var card = e.target.closest && e.target.closest('.tpo_image-swatches-wrapper');
    if (!card || e.target.closest('label')) return;
    var img = card.querySelector('label img.tpo_image-swatch-img') || card.querySelector('label');
    if (!img) return;
    var types = ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'];
    for (var i = 0; i < types.length; i++) {
      try { img.dispatchEvent(new MouseEvent(types[i], { bubbles: true, cancelable: true, view: window })); } catch (err) {}
    }
  }
  document.addEventListener('click', forward);

  function start() {
    run();
    try {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    } catch (e) {
      setInterval(run, 1500);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
